import script from "./LeaveManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveManagement.vue?vue&type=script&setup=true&lang=js"

import "./LeaveManagement.vue?vue&type=style&index=0&id=347ed09c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347ed09c"]])

export default __exports__